import api from "../api";
import auth from "../auth";
import func from "../func";

let members = {};
let loading = false;

export default {
    async search(id) {
        if (!func.isDefined(members[id])) {
            if (loading === true) {
                return func.sleep(250).then(() => {
                    return this.search(id);
                })
            }
            loading = true;
            members[id] = await api.v1.album.member.search(id)
                .finally(() => loading = false);
        }
        return members[id];
    },
    create(id, args) {
        return api.v1.album.member.create(id, args).then(() => delete members[id]);
    },
    delete(id, memberId, role) {
        return api.v1.album.member.delete(id, memberId, role).then(() => delete members[id]);
    },
    comment(id, memberId, role, comment) {
        return api.v1.album.member.comment(id, memberId, role, comment).then(() => delete members[id]);
    },
    async names(id, role) {
        let map = {};
        let res = await this.search(id);
        res.data.forEach(item => {
            map[item.id] = item.comment[role] || item.user.name || item.user.nick || item.user.mobile
        });
        return map;
    },
    async unique(id) {
        let userId = await auth.getUserId();
        let res = await this.search(id);
        for (let i = 0; i < res.total; i++) {
            if (res.data[i].user.id === userId) {
                res.data[i].closed = res.closed[res.data[i].id];
                return res.data[i];
            }
        }
        return {};
    },
};
